"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationDialog = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var react_1 = __importStar(require("react"));
var APText_1 = require("../elements/APText");
var APFlex_1 = require("../layout/APFlex");
function ConfirmationDialog(props) {
    var _a, _b;
    var _c = react_1.useState({ open: true, response: false }), state = _c[0], setState = _c[1];
    function onYes() {
        setState({
            open: false,
            response: true,
        });
    }
    function onNo() {
        setState({
            open: false,
            response: false,
        });
    }
    function onExited() {
        props.deferred.resolve(state.response);
    }
    return (react_1.default.createElement(Dialog_1.default, { onExited: onExited, open: state.open, disableBackdropClick: true, disableEscapeKeyDown: true },
        react_1.default.createElement(DialogTitle_1.default, { style: { maxWidth: "320px", minWidth: "300px", padding: "24px 20px 18px" } },
            react_1.default.createElement(APText_1.APText, { variant: 'dialogTitle' }, props.title)),
        react_1.default.createElement(DialogContent_1.default, { style: { maxWidth: "320px", minWidth: "300px", padding: "8px 20px " } }, props.body),
        react_1.default.createElement(APFlex_1.APRow, { style: { padding: "18px 20px" }, gap: "12px", mainAxisSize: "max", mainAxisAlignment: "end" },
            react_1.default.createElement(Button_1.default, { onClick: onNo, style: { minWidth: "72px", color: "#666" } }, (_a = props.noAction) !== null && _a !== void 0 ? _a : "Cancel"),
            react_1.default.createElement(Button_1.default, { color: "primary", variant: 'contained', autoFocus: true, onClick: onYes, style: { minWidth: "72px" } }, (_b = props.yesAction) !== null && _b !== void 0 ? _b : "Yes"))));
}
exports.ConfirmationDialog = ConfirmationDialog;
